import { derived, writable } from "svelte/store";
import translations from "./translations";
import { logger } from "./logger";

/**
 * Usage:-
  <script>
    import { t,  locale, locales } from "$lib/services/i18n";

    // Create a locale specific timestamp
    $: time = new Date().toLocaleDateString($locale, {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  </script>

  <h1>{$t("homepage.title")}!</h1>
  <p>{@html $t("homepage.welcome", { name: "Jane Doe" })}!</p>

 */

// Is below sitemap service

// @NOTE:  all locales set manualy to prevent  erors if new language will be added
export const locale = writable("en");
export const locales = new Set(["en", "locale-example"]);

// client side render
// if (browser) {
// }

function translate(locale: string, key: string, vars: Record<string, any>) {
  // Let's throw some errors if we're trying to use keys/locales that don't exist.
  // We could improve this by using Typescript and/or fallback values.
  if (!key) {
    const msg = "no key provided to $t()";
    logger.error(msg);
    throw new Error(msg);
  }

  if (!locale) {
    const msg = `no translation for key "${key}"`;
    logger.error(msg);
    throw new Error(msg);
  }

  // Grab the translation from the translations object.
  const text = (translations as Record<string, Record<string, string>>)?.[locale]?.[key] || key;
  if (!text) {
    const msg = `no translation found for ${locale}.${key}`;
    logger.error(msg);
    throw new Error(msg);
  }

  // Replace any passed in variables in the translation string.
  return parseTemplate(text)(vars);
}

export const t = derived(locale, $locale => {
  return (key: string, vars = {}) => translate($locale, key, vars);
});

// Similar to handle-bars templating
// E.g. Usage:-
// var terped = parseTemplate('The {speed} {fox.color} {mammal[2]} jumped over the lazy {mammal[0]}')({
// speed: 'quick',
// fox: { color: 'brown' },
// mammal: ['dog', 'cat', 'fox']
// });
function parseTemplate(str: string): (data: Record<string, string | number>) => string {
  return (o: Record<string, string | number>) =>
    str.replace(/{{([^{}]*)}}/g, (a: any, b: string) => {
      const r = o[b];
      return typeof r === "string" || typeof r === "number" ? `${r}` : a;
    });
}
